/**
 * @file AI 润色优化组件
 * @author malcolmmzma
 */

import { PromptOptimize as PromptOptimizeComp } from '@tencent/ai-chat-react';
import _ from 'lodash';
import React, { useCallback } from 'react';

import { createSessionId } from '../../../../api';
import { chatDirect } from '../../../../api/analysis';

const PromptOptimize = (props: {
  initialPrompt?: string;
  getPrompt?: () => string;
  onOptimize?: (optimizedPrompt: string) => void;
}) => {
  const { getPrompt } = props;

  const action = useCallback(async (val: string) => {
    try {
      const sessionId = await createSessionId({
        agent_id: 9,
        title: `AI润色 - ${val}`,
      });
      const result = await chatDirect({
        session_id: sessionId,
        agent_id: 9,
        messages: {
          content: val,
        },
      });
      const optimizedPrompt = _.get(result, 'choices.0.message.content', val) as string;
      return optimizedPrompt;
    } catch (error) {
      return val;
    }
  }, []);

  return <PromptOptimizeComp optimizeAction={action} getInitialPrompt={getPrompt} {...props} />;
};

export default PromptOptimize;
